<template>
  <layout 
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template #actions>
      <action-group class="hidden md:flex">
        <evaluation-action-text />

        <favorite v-if="canFavorite" />
        <skip v-if="canSkip" />
      </action-group>

      <action-group>
        <message />
      </action-group>
    </template>
  </layout>
</template>

<script>
import Layout from "./Layout";
import ActionGroup from "@/components/Navbar/ActionGroup";
import Favorite from "./Buttons/Favorite";
import Skip from "./Buttons/Skip";
import Message from "./Buttons/Message";
import EvaluationActionText from "@/components/AthleteProfile/EvaluationActionText";
import { mapGetters } from "vuex";

export default {
    components: {
        Layout,
        ActionGroup,
        Favorite,
        Skip,
        Message,
        EvaluationActionText,
    },

    computed: {
        ...mapGetters("athleteProfile", [
            "canFavorite",
            "canSkip",
            "favoritesReceived",
            "skips",
        ]),

        isFavorited() {
            return this.favoritesReceived.length > 0;
        },

        isSkipped() {
            return this.skips.length > 0;
        },
    },
};
</script>